import { WatchQueryFetchPolicy } from "@apollo/client";
import { useAuthState } from "@saleor/sdk";
import last from "lodash/last";

import {
	AddressDetailsFragment,
	AddressTypeEnum,
	useCurrentUserAddressesQuery,
} from "@/saleor/api";

export const useAccountAddress = (
	fetchPolicy: WatchQueryFetchPolicy = "cache-first"
): [(type?: AddressTypeEnum, strict?: boolean) => AddressDetailsFragment | undefined, boolean] => {
	const { authenticated } = useAuthState();
	const { data, loading } = useCurrentUserAddressesQuery({
		skip: !authenticated || typeof window === "undefined",
		fetchPolicy,
	});

	const getAddress = (
		type?: AddressTypeEnum,
		strict?: boolean
	): AddressDetailsFragment | undefined => {
		if (type) {
			const address =
				data?.me?.addresses?.find((add) => {
					return (
						(type === AddressTypeEnum.Billing && add?.isDefaultBillingAddress) ||
						(type === AddressTypeEnum.Shipping && add?.isDefaultShippingAddress)
					);
				}) || undefined;
			if (!address && !strict) {
				return last(data?.me?.addresses) || undefined;
			}
			return address;
		}
		return last(data?.me?.addresses) || undefined;
	};

	return [getAddress, loading];
};

export default useAccountAddress;
